import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { ConfigService } from '../../../core/services/config.service';

export const demoGuard: CanActivateFn = (): boolean | UrlTree => {
  const configService = inject(ConfigService);
  if (configService.isDemoMode()) {
    return true;
  }
  const router = inject(Router);
  return router.parseUrl('/');
};
